import React from 'react';
import { TablePagination } from '@mui/material';

interface ListPaginationProps {
  page: number;
  limit: number;
  total: number;
  onPageChange: (page: number) => void;
  onLimitChange?: (limit: number) => void;
}

/** 1-based API page → MUI TablePagination (0-based). */
const ListPagination: React.FC<ListPaginationProps> = ({
  page,
  limit,
  total,
  onPageChange,
  onLimitChange,
}) => {
  if (!total) return null;
  return (
    <TablePagination
      component="div"
      count={total}
      page={Math.max(0, page - 1)}
      onPageChange={(_, next) => onPageChange(next + 1)}
      rowsPerPage={limit}
      onRowsPerPageChange={
        onLimitChange
          ? (e) => {
              onLimitChange(parseInt(e.target.value, 10));
              onPageChange(1);
            }
          : undefined
      }
      rowsPerPageOptions={onLimitChange ? [25, 50, 100] : [limit]}
    />
  );
};

export default ListPagination;
